//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/events/views/main/lan/es';
import createEditEvent from 'Modules/events/views/.components/createEditEvent/lan/es';
import deleteEvent from 'Modules/events/views/.components/deleteEvent/lan/es';
import unitTypeEvents from 'Modules/events/.components/unitTypeEvents/lan/es';
import createEditUnitTypeEvent from 'Modules/events/.components/createEditUnitTypeEvent/lan/es';
import deleteUnitTypeEvent from 'Modules/events/.components/deleteUnitTypeEvent/lan/es';

locales = {
    ...locales,
    ...main,
    ...createEditEvent,
    ...deleteEvent,
    ...unitTypeEvents,
    ...createEditUnitTypeEvent,
    ...deleteUnitTypeEvent,
};


export default locales;